import { Drawer } from '@mui/material';
import { X } from 'lucide-react';
import { colors, radius, spacing, fonts, fontWeights } from '@/theme/tokens';
import { AssistantFeed } from './AssistantFeed';

interface AssistantFeedSheetProps {
  open: boolean;
  onClose: () => void;
}

export function AssistantFeedSheet({ open, onClose }: AssistantFeedSheetProps) {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: `${radius.lg} ${radius.lg} 0 0`,
          maxHeight: '70vh',
          backgroundColor: colors.bg,
          padding: `${spacing[4]} ${spacing[4]} ${spacing[6]}`,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* Sheet header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: spacing[4],
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontFamily: fonts.body,
            fontSize: '16px',
            fontWeight: fontWeights.semibold,
            color: colors.textPrimary,
          }}
        >
          Insights
        </span>
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: colors.textMuted,
            display: 'flex',
            alignItems: 'center',
            padding: spacing[1],
            borderRadius: radius.md,
          }}
        >
          <X size={20} />
        </button>
      </div>

      {/* Scrollable feed content */}
      <div style={{ overflowY: 'auto', flex: 1 }}>
        <AssistantFeed />
      </div>
    </Drawer>
  );
}
